import gql from 'graphql-tag';

// TODO: replace with USER_FAVOURITES_QUERY
// and useIsLoggedIn hook for user state
// user state now available in redux (see _app)
export const SAVED_LISTINGS_QUERY = gql`
    query {
        user {
            loggedIn
        }
        favourites {
            listings
        }
    }
`;

export const ADD_SAVED_LISTING_MUTATION = gql`
    mutation favouriteListing($id: ID!) {
        saveFavouriteListing(id: $id)
    }
`;

export const REMOVE_SAVED_LISTING_MUTATION = gql`
    mutation unfavouriteListing($id: ID!) {
        deleteFavouriteListing(id: $id)
    }
`;
